export const isDataReady = (accounts) => {
	for (const element of accounts) {
		if (element.status === 'READY') {
			return 'PARTIAL';
		}
	}
	return 'FAILED';
};

export const getLinkRefNumbers = (accounts) => {
	let arr = [];
	if (!accounts) return arr;
	for (const acc of accounts) {
		arr.push(acc);
	}
	return arr;
};
